import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "q-gutter-y-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_export_to_report_btn = _resolveComponent("export-to-report-btn")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Export Search Results to Report",
    ref: "modal"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_export_to_report_btn, {
        label: "Export",
        "post-search-id": _ctx.postSearchId,
        "report-name": _ctx.reportName,
        flat: "",
        onExported: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onExport($event, false)))
      }, null, 8, ["post-search-id", "report-name"]),
      _createVNode(_component_export_to_report_btn, {
        label: "Export & View",
        "post-search-id": _ctx.postSearchId,
        "report-name": _ctx.reportName,
        color: "primary",
        onExported: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onExport($event, true)))
      }, null, 8, ["post-search-id", "report-name"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_input, {
          modelValue: _ctx.reportName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reportName) = $event)),
          label: "Report Name",
          outlined: ""
        }, null, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 512))
}